export default __webpack_public_path__ + "static/media/box3_title.38873293.png";